export default __webpack_public_path__ + "static/media/appstore_img.2269efda.png";